/**
 * Resolves tblMarketingStatus id from a list or detail row.
 * SFM list rows use PascalCase; B4 detail/CRUD may use camelCase.
 * @param {object | null | undefined} row
 * @returns {number | null}
 */
export function getMarketingStatusIdFromRow(row) {
    if (!row) {
        return null;
    }
    const raw = row.MarketingStatusId ?? row.marketingStatusId;
    if (raw == null || raw === '') {
        return null;
    }
    const parsed = Number(raw);
    return Number.isNaN(parsed) ? null : parsed;
}

/** @param {number} marketingStatusId */
export function getMarketingStatusRowPatchFields(marketingStatusId) {
    const id = Number(marketingStatusId);
    return {
        MarketingStatusId: id,
        marketingStatusId: id,
    };
}
